import { UserPermission } from '@bo-client/shared/models/userPermissions.enum';
import { UserRole } from '@bo-client/shared/models/user-roles.enum';

/**
 * Wer Standorte bearbeiten darf: Privileg `VIEW_COMPANY_LOCATIONS` **oder** eine der Rollen.
 * Gilt für den Menüeintrag „Standorte" und für die Bearbeitersicht der Seite
 * „Kontakt" — beide lesen diese Konstanten, damit die Regel an einer Stelle steht.
 */
export const COMPANY_LOCATIONS_PERMISSION: UserPermission = 'VIEW_COMPANY_LOCATIONS';
export const COMPANY_LOCATIONS_ROLES: UserRole[] = ['ROLE_ADMIN', 'ROLE_SUPERADMIN'];
